import axios from "axios";
import API_CONFIG from "../../Configurations/ApiDeclaration";

export function GetUploadedFileList(param, token) {
    const URL = API_CONFIG.GET_UPLOADED_FILE_LIST + param;
    const headers = {
        headers: { Authorization: `Bearer ${token}` },
    };
    return axios.get(URL, headers);
}

export function GetStoreContractList(param, token) {
    const URL = API_CONFIG.GET_STORE_CONTRACT_LIST + param;
    const headers = {
        headers: { Authorization: `Bearer ${token}` },
    };
    return axios.get(URL, headers);
}

export function GetFiledownloadById(param, token) {
    const URL = API_CONFIG.DOWNLOAD_COSOLIDATED_REPORTS + param;
    const headers = {
        headers: { Authorization: `Bearer ${token}` },
    };
    return axios.get(URL, headers);
}

export function GetRetryFileProcessById(param, token) {
    const URL = API_CONFIG.GET_RETRY_FILE_PROCESS + param;
    const headers = {
        headers: { Authorization: `Bearer ${token}` },
    };
    return axios.get(URL, headers);
}